import { z } from "astro/zod";

export async function getUnsplashImage({ query }: { query: string }) {
  const unsplashCoverRes = await fetch(
    `https://api.unsplash.com/search/photos?client_id=${import.meta.env.UNSPLASH_API_KEY}&query=${query}&plus=only`,
  ).then((res) => res.json());

  const parsed = responseSchema.parse(unsplashCoverRes);

  return parsed.results.at(Math.floor(Math.random() * parsed.results.length));
}

export const unsplashImageDataSchema = z.object({
  id: z.string(),
  //   slug: z.string(),
  //   width: z.number(),
  //   height: z.number(),
  //   blur_hash: z.string().nullable(),
  description: z.string().nullable(),
  alt_description: z.string().nullable(),
  urls: z.object({
    raw: z.string().url(),
    full: z.string().url(),
    regular: z.string().url(),
    // small: z.string().url(),
    // thumb: z.string().url(),
    // small_s3: z.string().url(),
  }),
  //   likes: z.number(),
  user: z.object({
    id: z.string(),
    updated_at: z.string(),
    username: z.string(),
    name: z.string(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    twitter_username: z.string().nullable(),
    portfolio_url: z.string().url().nullable(),
    bio: z.string().nullable(),
    location: z.string().nullable(),
    links: z.object({
      self: z.string().url(),
      html: z.string().url(),
      photos: z.string().url(),
      likes: z.string().url(),
      portfolio: z.string().url(),
      following: z.string().url().optional(),
      followers: z.string().url().optional(),
    }),
    profile_image: z.object({
      small: z.string().url(),
      medium: z.string().url(),
      large: z.string().url(),
    }),
  }),
});

const responseSchema = z.object({
  total: z.number(),
  total_pages: z.number(),
  results: z.array(unsplashImageDataSchema),
});
